export const sortRidePlanCandidates = (candidates = [], mode = "GROUP", viewerOrigin = null) => {
  const source = Array.isArray(candidates) ? candidates : [];
  if (mode !== "MINE" || !viewerOrigin) return source;

  return [...source].sort((a, b) => {
    const aDrive = a?.my_drive_minutes;
    const bDrive = b?.my_drive_minutes;
    if (aDrive == null && bDrive == null) return 0;
    if (aDrive == null) return 1;
    if (bDrive == null) return -1;
    return aDrive - bDrive;
  });
};
